<h2 class="title">Znajdź na stronie</h2>
<div class="search-page-holder">
  <div class="search-header">
    <p>Wyszukaj na stronie partnerów, ofert oraz znajdź potrzebne informacje o karcie i o programie.</p>
  </div>
  <div class="search-box">
    <mat-form-field appearance="outline">
      <mat-label>Wyszukaj</mat-label>
      <input matInput [formControl]="searchControl" (keyup.enter)="onSearch()" placeholder="Wpisz frazę..." />
      <button mat-icon-button matSuffix (click)="onSearch()">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button matSuffix (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="search-results">
    @if (!loading && results.length === 0) {
      <p style="text-align: center;">Brak wyników wyszukiwania.</p>
    }
    @if (!loading && results.length > 0) {
      <h2>Wyniki wyszukiwania</h2>
    }
    <div class="search-result-list">

      @for (result of results; track result) {
        <mat-card class="search-result-card" (click)="goToResult(result)">
          @if (result.thumb) {
            <img mat-card-image [src]="imagesUrl + result.thumbFolder + '/' + result.thumb"
              alt="{{ result.name }}" />
          } @else {
            <img mat-card-image class="default-image" src="icons/logo-cropped.svg" alt="{{ result.name }}" />
          }
          <mat-card-content>
            <div class="search-result-name"><strong>{{ result.name }}</strong></div>
            <div class="type">Typ: {{
              result.type === 'Offer' ? 'Oferta' :
              result.type === 'News' ? 'Wiadomość' :
              result.type === 'Page' ? 'Strona' :
              result.type === 'Partner' ? 'Partner' :
              result.type
            }}</div>

          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</div>